module.exports = __webpack_public_path__ + "img/avatar-page.d3791687.png";